import React from 'react';

export default function EditIcon({ svgClass }) {
  return (
    <svg className={svgClass} viewBox='0 0 8 8'>
      <path
        id='_Color'
        data-name=' ↳Color'
        d='M1.667,8H0V6.333L4.915,1.419,6.582,3.085Zm5.39-5.39h0L5.391.943,6.2.13a.443.443,0,0,1,.627,0l1.04,1.04a.444.444,0,0,1,0,.627l-.813.813Z'
      />
    </svg>
  );
}
